<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12">
      <h1>Посадочные страницы</h1>
    </v-col>
  <v-tabs v-model="tab">
    <v-tab>Теги</v-tab>
    <v-tab>СЕО</v-tab>
  </v-tabs>
  <v-tabs-items v-model="tab">
    <v-tab-item>

    <v-col cols="12" sm="12">
      <v-data-table
              no-data-text="Нет тегов"
              no-results-text="По заданному запросу ничего не найдено"
              :headers="headers"
              :items="tagLandings"
              :header-props="{sortIcon: 'icon-custom-arrow'}"
              :options.sync="options"
              :footer-props="footerProps"
              :server-items-length="total"
              :items-per-page="30"
              :loading="loading"
              loading-text="Загрузка тегов... Подождите пожалуйста"
      >
        <template v-slot:item.actions="{ item }">
          <div class="text-right">

            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                    small
                    class="mr-2"
                    v-bind="attrs"
                    v-on="on"
                >
                  mdi-dots-vertical
                </v-icon>
              </template>
              <v-list>
                <v-list-item @click="$router.push({ name: 'tag-landing-edit', params: { id: item.id } })">
                  <v-list-item-title>Редактировать</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
      </v-data-table>
      <!--</v-card>-->
    </v-col>
    <v-overlay
            :z-index="4"
            :value="overlay"
    >
    </v-overlay>

    </v-tab-item>
    <v-tab-item>
      <v-col class="text-right">
        <v-btn @click="$router.push({ name: 'seo-tag-landing-create'})">Создать</v-btn>
      </v-col>
      <v-col cols="12" sm="12">
        <v-data-table
            no-data-text="Нет сео-тегов"
            no-results-text="По заданному запросу ничего не найдено"
            :headers="headers2"
            :items="tagLandings"
            :header-props="{sortIcon: 'icon-custom-arrow'}"
            :options.sync="options"
            :footer-props="footerProps"
            :server-items-length="total"
            :items-per-page="30"
            :loading="loading"
            loading-text="Загрузка сео-тегов... Подождите пожалуйста"
        >
          <template v-slot:item.actions="{ item }">
            <div class="text-right">

              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                      small
                      class="mr-2"
                      v-bind="attrs"
                      v-on="on"
                  >
                    mdi-dots-vertical
                  </v-icon>
                </template>
                <v-list>
                  <v-list-item @click="$router.push({ name: 'seo-tag-landing-edit', params: { id: item.id } })">
                    <v-list-item-title>Редактировать</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="deleteSeoItem(item.id)">
                    <v-list-item-title>Удалить</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </template>
        </v-data-table>
        <!--</v-card>-->
      </v-col>
      <v-overlay
          :z-index="4"
          :value="overlay"
      >
      </v-overlay>

    </v-tab-item>
  </v-tabs-items>
  </v-row>
</template>

<script>
    // @ is an alias to /src

    import TagService from '../../api/TagService'
    import SeoTagService from '../../api/SeoTagService'

    export default {
        name: 'TagLandingIndex',
        components: {},
        data: () => ({
            overlay: false,
            search: '',
            loadingModal: false,
            loading: true,
            tab: 0,
            dialog: false,
            selected: [],
            tagLandings: [],
            options: {},
            promocode: {
                id: null,
                name: '',
                name_ua: '',
            },
            footerProps: {
                itemsPerPageText: 'Промокодов на страницу',
                pageText: '{0}-{1} из {2}',
                itemsPerPageAllText: 'Все',
              itemsPerPageOptions: [15, 30]
            },
            total: 0,
            headers: [
                {
                    text: 'Тег',
                    value: 'tag.name',
                    sortable: false
                },
                {
                    text: 'Категория',
                    value: 'category.name',
                    sortable: false
                },
                {text: 'Действия', value: 'actions', sortable: false, width: "5%"},

            ],
          headers2: [
            {
              text: 'Тег',
              value: 'title',
              sortable: false
            },
            {
              text: 'Url',
              value: 'slug',
              sortable: false
            },
            {text: 'Действия', value: 'actions', sortable: false, width: "5%"},

          ],
        }),
        mounted() {
        },
        watch: {
            search() {
              this.getDataFromApi()
            },
            options: {
                handler() {
                    this.getDataFromApi()
                },
                deep: true,
            },
          tab() {
            this.getDataFromApi();
          }
        },
        methods: {
            deleteSeoItem(id) {
              SeoTagService.delete({id}).then(() => {
                this.getDataFromApi();
              });
            },
            getDataFromApi() {
                this.loading = true
              this.selected = [];
                let params = {
                  page: this.options.page,
                }

                if (this.tab === 0) {
                  TagService.getListLandings(params)
                      .then(response => {
                        this.tagLandings = response.data.data
                        this.total = response.data.total
                        this.loading = false
                      });
                } else {
                  SeoTagService.getListLandings(params)
                      .then(response => {
                        this.tagLandings = response.data.data
                        this.total = response.data.total
                        this.loading = false
                      });
                }
            },
        }
    }
</script>

<style>
  .changed-row{
    background-color: #FFEEEC;
  }

  .v-tabs-items {
    width: 100%;
  }
</style>

<style lang="scss" scoped>
  .v-btn--fab.v-size--x-small {
    width: 20px;
    height: 20px;

    .mdi::before {
      font-size: 12px;
    }
  }
  span.v-btn{
    border-color: currentColor!important;
  }

  .filter-popup {
    position: absolute;
    width: 250px;
    z-index: 5;

    &:hover {
      cursor: auto;
    }



    &.v-card--link:focus::before {
      opacity: 0;
    }
  }
</style>
